module.exports = __webpack_public_path__ + "static/img/page7-bg.e6e2beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page7-bg.png
// module id = xkvG
// module chunks = 215